import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "amount" ]

  connect() {
    this.#toggleAmount()
  }

  toggle() {
    this.#toggleAmount()
  }

  #toggleAmount() {
    const fixed = this.element.querySelector("input[name='scheduled_transaction[amount_mode]']:checked")?.value === "fixed"
    this.amountTarget.classList.toggle("hidden", !fixed)
    this.amountTarget.querySelector("input").disabled = !fixed
  }
}
